<script lang="ts">
  interface Links {
    text: string;
    link?: string;
    regions: string[];
    newTab?: boolean;
  }

  import { _ } from "svelte-i18n";
  import { modals } from "$lib/stores/modal";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import AccordionItem from "$lib/components/AccordionItem/AccordionItem.svelte";
  import Link from "$lib/components/Link/Link.svelte";
  import { linkTo } from "$lib/utils/url";

  import { account } from "$lib/stores/account";
  import { onMount } from "svelte";

  export let title = "";
  export let links: Links[] = [];
  export let filteredLinks: Links[] = [];
  export let currentRegion = "";
  export let mobile = false;

  let isHovered = false;

  let masterCustomer = $account?.masterCustomer || false;

  onMount(async () => {
    masterCustomer = await account?.isMasterCustomer();
  });

  $: masterCustomer = $account?.masterCustomer;

  $: if (masterCustomer) {
    filteredLinks = links.filter(link => link.text !== "Circuit Newsletter");
  } else {
    filteredLinks = links.filter(link => link.text !== "circuitMaster.footer");
  }
</script>

<style lang="scss">
  .container {
    color: $inverse-on-surface;
  }
  .heading {
    padding-bottom: 16px;
  }
  .footer-link-list {
    &--mobile-link {
      padding: 12px 0;
    }

    &--link {
      display: block;
      margin-bottom: 8px;

      &--size-guide {
        text-decoration: none;
        padding: 12px 0;
        margin-bottom: 0;

        &:hover {
          cursor: pointer;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
</style>

<div class="container">
  {#if title && !mobile}
    <div class="heading">
      <Typography component="p" variant="overline" theme="inverse-on-surface">
        {$_(title)}
      </Typography>
    </div>
  {/if}
  {#if links.length >= 1 && !mobile}
    <div class="footer-link-list">
      {#key filteredLinks}
        {#each filteredLinks as { link, text, regions, newTab }}
          {#if regions.includes(currentRegion)}
            <div class="footer-link-list--link">
              <Link
                text={$_(text)}
                href={$_(link)}
                underline={false}
                standard={true}
                theme="inverse-on-surface"
                hoverTheme="inverse-on-surface-60"
                newTab={newTab ? true : false}
              />
            </div>
          {/if}
        {/each}
      {/key}
    </div>
  {:else if links.length >= 1 && mobile}
    <div class="footer-link-list">
      <AccordionItem
        title={$_(title)}
        innerBorder={false}
        innerPadding={"0px 0px 12px"}
        light
        footerLinks
      >
        {#key filteredLinks}
          {#each filteredLinks as { link, text, regions, newTab }}
            {#if regions.includes(currentRegion)}
              {#if text === "privacyPolicy.title"}
                <a
                  href={linkTo("legal/privacy-policy")}
                  class="footer-link-list--link footer-link-list--link--size-guide"
                  on:mouseenter={() => (isHovered = true)}
                  on:mouseleave={() => (isHovered = false)}
                  on:click|preventDefault={() => {
                    modals.open("privacyPolicy");
                  }}
                >
                  <Typography
                    theme={isHovered
                      ? "inverse-on-surface-60"
                      : "inverse-on-surface"}
                    variant="body1">{$_("privacyPolicy.title")}</Typography
                  >
                </a>
              {:else}
                <div class="footer-link-list--mobile-link">
                  <Link
                    text={$_(text)}
                    href={$_(link)}
                    underline={false}
                    standard={true}
                    theme="inverse-on-surface"
                    hoverTheme="inverse-on-surface-60"
                    newTab={newTab ? true : false}
                  />
                </div>
              {/if}
            {/if}
          {/each}
        {/key}
      </AccordionItem>
    </div>
  {:else}
    <slot name="item" />
  {/if}
</div>
